import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank-layout',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: [
  ]
})
export class BlankLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
